import _ from "lodash";
import { takeEvery, all, fork, put } from "redux-saga/effects";
import { GET_CUSTOMER_BOOKING_PAGE } from "../constants/ActionTypes";
import axios from "../services/customer";
import * as actions from "../actions";

function* getCustomerBookingPageDetails() {
  try {
    const response = yield axios.get(`/businesstypes`);
    const mainData = response.data.map(item => _.pick(item, ["name", "_id", "businesses"]));
    yield put(actions.setCustomerBookingPage(mainData));
  } catch (error) {}
}

export function* requestCustomerBookingPage() {
  yield takeEvery(GET_CUSTOMER_BOOKING_PAGE, getCustomerBookingPageDetails);
}

export default function* rootSaga() {
  yield all([fork(requestCustomerBookingPage)]);
}



// WEBPACK FOOTER //
// ./sagas/CustomerBooking.js